import type { Step } from "react-joyride";

export const templateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການຮ່າງເອກະສານ! ຮ່າງເອກະສານ (Template) ແມ່ນແບບຟອມມາດຕະຖານທີ່ໃຊ້ສໍາລັບການດໍາເນີນງານຕ່າງໆ ໃນອົງກອນ ເຊັ່ນ ຮ່າງເອກະສານ PO (ສັ່ງຊື້), PR (ການຊື້), ບີນ, ອິນວອຍສ໌, ກອນເທຣັກ ແລະອື່ນໆ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="template-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງຮ່າງເອກະສານໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງຮ່າງເອກະສານທີ່ທ່ານຕ້ອງການ. ຮ່າງເອກະສານຈະຊ່ວຍທ່ານກໍານົດແບບຟອມມາດຕະຖານສໍາລັບການດໍາເນີນງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="template-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາຮ່າງເອກະສານຕາມຊື່, ພະແນກ, ຫຼືສະຖານະ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="template-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງຮ່າງເອກະສານທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ເປີດ/ປິດການໃຊ້ງານ, ຫຼືລຶບຮ່າງເອກະສານໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະຮ່າງເອກະສານ. ທ່ານຍັງສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງຮ່າງເອກະສານແຕ່ລະຕົວ.",
    placement: "top",
  },
];
